var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"previous-step__container"},[_c('button',{staticClass:"previous-step__link",on:{"click":_vm.back}},[_vm._v("Back a step")])])
}
var staticRenderFns = []

export { render, staticRenderFns }